import { css } from '@emotion/css';
import { Button, Content, Headline, Headline2 } from '@volumental/common';
import { type JSX } from 'react';

const imageContainer = css`
  margin: 24px 0 16px 0;
  overflow-y: hidden;
  max-height: calc(100dvh - 320px);
`;
const feetImages = css`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 12px;
  background: #eff6fa;
`;

interface OnboardingStartPageProps {
  text: string;
  description: string;
  imageSrc: string;
  buttonText: string;
  onClick?: () => void;
  altText: string;
}
export function OnboardingStartPage({
  text,
  description,
  imageSrc,
  buttonText,
  onClick,
  altText,
}: OnboardingStartPageProps): JSX.Element {
  return (
    <>
      <Content disableScrollbar>
        <Headline style={{ fontSize: '21px', lineHeight: 'normal' }}>
          {text}
        </Headline>
        <Headline2
          style={{
            fontSize: '16px',
            fontWeight: 'normal',
            lineHeight: 'normal',
          }}
        >
          {description}
        </Headline2>

        <div className={imageContainer}>
          <img
            className={feetImages}
            data-cy="onboarding-start-image"
            src={imageSrc}
            alt={altText}
          />
        </div>
      </Content>
      <div style={{ padding: '24px' }}>
        <Button type="submit" onClick={onClick}>
          {buttonText}
        </Button>
      </div>
    </>
  );
}
